import { Badge, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { messageService } from "../../pages/message_center/services/messageServices";

// This component wraps the icon with a badge
function MessageCenterBadge(icon) {
  const [unreadCount, setUnreadCount] = useState(0);
  const location = useLocation();

  useEffect(() => {
    fetchUnreadCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]); // Refresh when navigation changes

  const fetchUnreadCount = async () => {
    try {
      const counts = await messageService.getUnreadCounts();
      setUnreadCount(counts.total);
    } catch (error) {
      console.error("Error fetching unread count for badge:", error);
      setUnreadCount(0);
    }
  };

  return (
    <Badge
      badgeContent={unreadCount > 0 ? unreadCount : null}
      color="error"
      sx={{
        width: "100%",
        height: "100%",
        "& .MuiBadge-badge": {
          fontSize: "0.6rem",
          height: "16px",
          minWidth: "16px",
          padding: "0 3px",
          right: 15,
          top: 2
        }
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {icon}
      </Box>
    </Badge>
  );
}

export default MessageCenterBadge;
